import { render, staticRenderFns } from "./VNavLink.vue?vue&type=template&id=1da63dfb&"
import script from "./VNavLink.vue?vue&type=script&lang=js&"
export * from "./VNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports